// Pokemon sprites served locally from public/sprites/
// Gen 5 (BW) pixel-art style

import { isMegaStone } from './baseStats';

// Generic Mega Stone fallback — used when no local sprite exists for
// a given mega stone (e.g. fanmade stones like Dragonitite).
export const MEGA_STONE_FALLBACK = "data:image/svg+xml;utf8," + encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'>
    <defs>
      <radialGradient id='g' cx='35%' cy='30%' r='70%'>
        <stop offset='0%' stop-color='#ffffff'/>
        <stop offset='45%' stop-color='#c4b5fd'/>
        <stop offset='100%' stop-color='#6d28d9'/>
      </radialGradient>
    </defs>
    <circle cx='16' cy='16' r='13' fill='url(#g)' stroke='#3b0764' stroke-width='1.5'/>
    <path d='M16 6 L21 14 L16 24 L11 14 Z' fill='#ffffff' opacity='0.7'/>
  </svg>`
);

/**
 * onError handler for item <img> tags. Swaps in the generic mega-stone
 * orb when the item is a Mega Stone without a local sprite; otherwise hides.
 */
export function handleItemIconError(e, itemName) {
  if (isMegaStone(itemName) && e.target.src !== MEGA_STONE_FALLBACK) {
    e.target.src = MEGA_STONE_FALLBACK;
  } else {
    e.target.style.display = 'none';
  }
}


// Known form suffixes that use hyphens in Showdown sprite filenames
const FORM_SUFFIXES = [
  '-Alola', '-Galarian', '-Hisui', '-Paldea', '-Paldea-Blaze', '-Paldea-Aqua',
  '-Heat', '-Wash', '-Frost', '-Fan', '-Mow',
];

function toSpriteId(name) {
  // Check for form suffix
  let base = name;
  let suffix = '';
  for (const s of FORM_SUFFIXES) {
    if (name.endsWith(s)) {
      base = name.slice(0, -s.length);
      suffix = s.toLowerCase().replace('galarian', 'galar');
      break;
    }
  }

  // Clean base name: lowercase, strip all non-alpha
  const cleanBase = base.toLowerCase().replace(/[^a-z]/g, '');

  return cleanBase + suffix;
}

export function getSpriteUrl(name) {
  return `${process.env.PUBLIC_URL}/sprites/${toSpriteId(name)}.png`;
}

/**
 * Get the type icon URL (e.g. Fire, Water, Electric).
 */
export function getTypeIconUrl(typeName) {
  return `${process.env.PUBLIC_URL}/types/${typeName.toLowerCase()}.svg`;
}

/**
 * Get the item sprite URL.
 */
export function getItemSpriteUrl(itemName) {
  const id = itemName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '');
  return `${process.env.PUBLIC_URL}/items/${id}.png`;
}

/**
 * Get the mega evolution sprite URL for a Pokemon.
 * stoneName is used to distinguish X vs Y for Charizard/Mewtwo.
 */
export function getMegaSpriteUrl(name, stoneName) {
  const base = toSpriteId(name);
  if (stoneName && stoneName.includes(' X')) return `${process.env.PUBLIC_URL}/sprites/${base}-megax.png`;
  if (stoneName && stoneName.includes(' Y')) return `${process.env.PUBLIC_URL}/sprites/${base}-megay.png`;
  return `${process.env.PUBLIC_URL}/sprites/${base}-mega.png`;
}
